import "./ScaffoldingInClapham.module.css";
import Header from "@/reusable_sections/Header";
import ClaphamHero from "./sections/ClaphamHero";
import Clapham from "./sections/Clapham";
import ClaphamServices from "./sections/ClaphamServices";
import AccessSafety from "./sections/AccessSafety";
import FaqClapham from "./sections/FaqClapham";
import Cta from "./sections/Cta";
import Footer from "@/reusable_sections/Footer";
export default function ScaffoldingInClaphamPage() {
  return <div>
      <Header />
      <ClaphamHero />
      <Clapham />
      <ClaphamServices />
      <AccessSafety />
      <FaqClapham />
      <Cta />
      <Footer />
    </div>;
}